const palette = {
  secondary: {
    main: "#FFA500",
  },
};

export default palette;
